module.exports = __webpack_public_path__ + "img/shape-footer-desktop-total.e025db0a23ce2267104ef12f0768a681.svg";